<script lang="ts" setup>
import {computed, ref} from "vue";

import NoConversation from "@src/components/states/empty-states/NoConversation.vue";
import Circle2Lines from "@src/components/states/loading-states/Circle2Lines.vue";
import SearchInput from "@src/components/ui/inputs/SearchInput.vue";
import FadeTransition from "@src/components/ui/transitions/FadeTransition.vue";
import SidebarHeader from "@src/components/views/HomeView/Sidebar/SidebarHeader.vue";
import SessionList from "@src/components/shared/session/SessionList.vue";
import NotifyToggle from "@src/components/ui/inputs/NotifyToggle.vue";

import {useBotSessions} from "@src/stores/botSessions";
import {storeToRefs} from 'pinia';
import ChatSession from "@src/types/ChatSession";
import InformationIcon from "@src/components/ui/utils/InformationIcon.vue";

const store = useBotSessions();
const {sessions: botSessions} = storeToRefs(store);

const search = ref<string>('')
const filteredSessions = computed(() => {
    if (!search.value.toLocaleLowerCase()) {
        return botSessions.value
    }

    let response: ChatSession[] = []
    botSessions.value?.forEach(s => {
        if (s.costumer?.name?.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())
            || s.costumer?.token.includes(search.value)) {
            response.push(s)
        } else if (s.costumer.contact) {
            if (s.costumer.contact.name?.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())
                || s.costumer.contact.nickname?.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())
                || s.costumer.contact.reference?.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())) {
                response.push(s)
            }
        }
    })
    return response
});

</script>

<template>
    <div>
        <SidebarHeader>
            <!--title-->
            <template v-slot:title>
              Fluxo
              <InformationIcon title="Fluxo" text="Gerencie os clientes que estão interagindo com a IA" class="mb-2" ></InformationIcon>
            </template>
            <template v-slot:actions>
                <div class="flex items-center">
                    <NotifyToggle type="bots"/>
                </div>
            </template>
        </SidebarHeader>


        <!--search bar-->
        <div class="px-5 xs:pb-6 md:pb-5">
            <SearchInput
                :value="search"
                @value-changed="value => search = value"
            />
        </div>

        <div v-if="filteredSessions && filteredSessions.length > 0" class="flex w-full text-center mb-4">
            <h1 class="w-full heading-2 text-gray-400">{{ filteredSessions?.length }}
                {{ filteredSessions?.length === 1 ? 'atendimento' : 'atendimentos' }} interagindo com o bot</h1>
        </div>
        <!--conversations-->
        <div
            aria-label="conversations"
            class="w-full h-full scroll-smooth scrollbar-hidden"
            role="list"
            style="overflow-x: visible; overflow-y: scroll"
        >
            <Circle2Lines
                v-for="item in 6"
                v-if="store.status === 'loading'"
            />

            <div v-else>
                <div
                    v-if="
                    store.status === 'success' &&
                    botSessions
                  "
                >
                    <FadeTransition>
                        <SessionList :sessions="filteredSessions"/>
                    </FadeTransition>
                </div>

                <div v-else>
                    <NoConversation v-if="store.sessions?.length === 0"/>
                </div>
            </div>
        </div>
    </div>
</template>
